import Nav from "react-bootstrap/Nav";
import IconSpan from "./IconSpan";
import React from "react";
import {MenuItem as SidebarMenuItem } from "./sidebarMenuItems";


function addActiveClasses(href: string) {
    return window.location.pathname.startsWith(href) ? 'bg-darker text-white' : 'hover-bg';
}

/**
 * Render an option in the Menu sidebar.
 */
export default function RenderOption({ className, option, collapsed }: {
    option: SidebarMenuItem;
    collapsed: boolean;
    className: string;
}) {
    return (
        <Nav.Item
            as="a"
            className={`${className} ${addActiveClasses(option.href)}`}
            href={option.href}
            style={{ height: '45px'}}
        >
            {option.icon && (
              <IconSpan
                icon={option.icon}
                tooltip={collapsed ? option.label : undefined}
                width={collapsed ? 38 : 60}
              />
            )}
            <span className={collapsed ? "d-none" : "d-sm-inline-block"}>
                {option.label}
            </span>
        </Nav.Item>
    )
}
